'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Nav = require('react-bootstrap/lib/Nav');

var _Nav2 = _interopRequireDefault(_Nav);

var _NavDropdown = require('react-bootstrap/lib/NavDropdown');

var _NavDropdown2 = _interopRequireDefault(_NavDropdown);

var _MenuItem = require('react-bootstrap/lib/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BinaryNavigationItem = function (_Component) {
  _inherits(BinaryNavigationItem, _Component);

  function BinaryNavigationItem(props) {
    _classCallCheck(this, BinaryNavigationItem);

    var _this = _possibleConstructorReturn(this, (BinaryNavigationItem.__proto__ || Object.getPrototypeOf(BinaryNavigationItem)).call(this, props));

    _this.styles = require('./BinaryNavigationItem.scss');
    return _this;
  }

  _createClass(BinaryNavigationItem, [{
    key: 'onTouchTap',
    value: function onTouchTap() {
      var onTouchTap = this.props.onTouchTap;

      if (onTouchTap) {
        onTouchTap();
      }
    }
  }, {
    key: 'getItemsElem',
    value: function getItemsElem() {
      var _this2 = this;

      var _props = this.props,
          index = _props.index,
          items = _props.items;

      var DATA = [];
      items.forEach(function (item, index_) {
        DATA.push(_react2.default.createElement(
          _MenuItem2.default,
          { id: item.id ? item.id : '', className: _this2.getClassName(item.name, false), onTouchTap: item.onTouchTap.bind(_this2), key: index + '.' + index_, eventKey: index + '.' + index_ },
          _react2.default.createElement(
            'span',
            null,
            item.name
          )
        ));
      });
      return DATA;
    }
  }, {
    key: 'getClassName',
    value: function getClassName(name) {
      var header = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _props2 = this.props,
          title = _props2.title,
          current = _props2.current;

      var className = null;

      if (current && current.split('>').map(function (str) {
        return str.trim();
      }).indexOf(name.split(' ').join('').toLowerCase()) !== -1) {
        className = header ? this.styles.binary_navigation_highlight : this.styles.binary_navigation_sub_highlight;
      } else {
        className = header ? this.styles.binary_navigation_nav : this.styles.binary_navigation_sub;
      }
      if (header && (typeof title === 'undefined' ? 'undefined' : _typeof(title)) === 'object') {
        className = className + ' ' + this.styles.binary_navigation_nav_noarrow;
      }
      return className;
    }
  }, {
    key: 'getNavigation',
    value: function getNavigation() {
      var _props3 = this.props,
          index = _props3.index,
          title = _props3.title;

      var type = typeof title === 'undefined' ? 'undefined' : _typeof(title);
      var items = this.getItemsElem();
      var className = this.getClassName(title, true);
      var DATA = _react2.default.createElement(
        _NavDropdown2.default,
        {
          id: 'binary_header_nav_menu_' + Math.random(),
          className: items.length > 0 ? className : className + ' ' + this.styles.no_drop_down,
          key: index,
          eventKey: index,
          title: title,
          onTouchTap: this.onTouchTap.bind(this)
        },
        items
      );
      if (type === 'object') {
        return _react2.default.createElement(
          _Nav2.default,
          { className: this.styles.binary_navigation_item },
          DATA
        );
      }
      return DATA;
    }
  }, {
    key: 'render',
    value: function render() {
      return this.getNavigation();
    }
  }]);

  return BinaryNavigationItem;
}(_react.Component);

BinaryNavigationItem.propTypes = {
  index: _propTypes2.default.number,
  current: _propTypes2.default.string,
  title: _propTypes2.default.oneOfType([_propTypes2.default.string.isRequired, _propTypes2.default.object.isRequired]),
  onTouchTap: _propTypes2.default.func,
  items: _propTypes2.default.array.isRequired // name: , onTouchTap:
};
BinaryNavigationItem.defaultProps = {
  index: 1
};
exports.default = BinaryNavigationItem;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryNavigationItem/BinaryNavigationItem.js
// module id = 1087
// module chunks = 1